// extracted by mini-css-extract-plugin
export var content = "articleHero-module--content--14970";
export var contentWrapper = "articleHero-module--contentWrapper--67224";
export var heading = "articleHero-module--heading--d0ce0";
export var heroImg = "articleHero-module--heroImg--2dde7";
export var heroImgBg = "articleHero-module--heroImgBg--b61ac";
export var heroText = "articleHero-module--heroText--472f7";
export var subHeading = "articleHero-module--subHeading--6a3e1";
export var wrapper = "articleHero-module--wrapper--637e2";